import {doGet} from './Base';


const getLinkViews = async(domain, id) => {
  const url = '/reports/' + domain + '/' + id + '/views';
  const response_json = await doGet(url);
  return response_json;
}

export default getLinkViews;
